import { MoreVertical } from "react-feather";
import { ActionMenu } from "@/Components/ActionMenu";
import React, { useRef, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import { copyToClipboard, formatDate } from "@/Utilities/Utilities";
import CalculatorDialogCenter from "@/Pages/Organization/Calculators/Partials/CalculatorDialogCenter";
import { toast } from "react-toastify";

const CalculatorRow = ({ calculator, team }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleCopy = () => {
    copyToClipboard(calculator.shareable_url).then((success) => {
      if (success) {
        toast.success("Shareable link copied to clipboard");
      } else {
        toast.error("Failed to copy link to clipboard");
      }
    });
  };

  const handleExport = () => {
    axios({
      method: "get",
      url: route("calculators.export", {
        team: team.id,
        calculator: calculator.id,
      }),
      responseType: "blob",
    })
      .then((response) => {
        setTimeout(() => {
          // Create a Blob from the PDF Stream
          const file = new Blob([response.data], {
            type: "application/octet-stream",
          });
          // Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          // Open the URL on new Window
          const link = document.createElement("a");
          link.href = fileURL;
          const filename = `${calculator.name}-exported-${new Date().toISOString().replace(/:/g, "-")}.xlsx`;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          link.remove();

          toast.success(
            "Successfully downloaded calculator results Excel-file.",
            {
              autoClose: 5000,
            },
          );
        }, 1000);
      })
      .catch((error) => {
        toast.error("An error occurred while generating the file.", {
          autoClose: 5000,
        });
      });
  };

  const actionMenuItems = [
    {
      label: "Copy link",
      callback: handleCopy,
    },
    {
      label: "Edit calculator",
      callback: () => {
        Inertia.visit(
          route("calculators.edit", {
            team: team.id,
            calculator: calculator.id,
          }),
        );
      },
    },
    {
      label: "Export results",
      callback: () => handleExport(),
    },
    {
      label: "Delete calculator",
      callback: () => setShowDeleteModal(true),
    },
  ];

  const actionMenuRef = useRef(null);

  return (
    <>
      <div className="grid-rows-[repeat(2, auto)] mb-2 grid min-h-[53px] grid-cols-4 gap-2 bg-gray-light p-4 shadow-small md:grid-flow-col-dense md:grid-cols-12 md:grid-rows-1 md:p-8 md:px-4 md:py-2">
        <div className="col-span-3 flex items-center md:col-span-6">
          <h3 className="truncate font-bold leading-none">{calculator.name}</h3>
        </div>
        <div className="col-span-4 flex items-center justify-end md:col-span-5">
          {`${formatDate(calculator.start_date)} - ${formatDate(calculator.end_date)}`}
        </div>
        <div className="col-span-1 col-start-4 row-start-1 flex items-center justify-end md:col-start-12">
          <div className="hover-circle relative z-10 ml-2">
            <MoreVertical
              size={24}
              className="shrink-0 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            />
            <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
          </div>
        </div>
      </div>

      <CalculatorDialogCenter
        team={team}
        calculator={calculator}
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
      />
    </>
  );
};

export default CalculatorRow;
